module.exports = __webpack_public_path__ + "img/Error404.0f95c100.png";